export const sampleDetailsRouteConfig = (id: string) => [
    { routerLink: `/dashboard/sample-details/${id}`, title: 'Details' },
    { routerLink: `/dashboard/sample-result/${id}`, title: 'Analysis' },
    { routerLink: `/dashboard/sample-history/${id}`, title: 'History' }
];